import { apiClient } from "@/lib/apiClient";

export interface UserAddress {
  address_line_one: string;
  address_line_two: string;
  city: string;
  state: string;
  postal_code: string;
}

export interface UserProfile {
  name?: string;
  email?: string;
  phone_number?: string;
  address?: UserAddress;
}

export interface UpdateUserRequest {
  name?: string;
  email?: string;
  address?: UserAddress;
}

export interface UserResponse {
  message: string;
  valid: boolean;
  data: UserProfile;
}

export async function getUserProfile(
  storeId: string,
  userId: string,
): Promise<UserProfile> {
  try {
    const response = await apiClient.get<UserProfile>(
      `/api/v1/admin/${storeId}/user/${userId}`,
    );

    if (!response.valid) {
      throw new Error(response.message || "Failed to fetch user profile");
    }

    return response.data;
  } catch (error) {
    console.error("Get user profile error:", error);

    if (error instanceof Error) {
      throw error;
    }

    throw new Error("Network error occurred while fetching user profile");
  }
}

export async function updateUserProfile(
  storeId: string,
  userId: string,
  userData: UpdateUserRequest,
): Promise<UserProfile> {
  try {
    const response = await apiClient.put<UserProfile>(
      `/api/v1/admin/${storeId}/user/${userId}`,
      userData,
    );

    if (!response.valid) {
      throw new Error(response.message || "Failed to update user profile");
    }

    return response.data;
  } catch (error) {
    console.error("Update user profile error:", error);

    if (error instanceof Error) {
      throw error;
    }

    throw new Error("Network error occurred while updating user profile");
  }
}
